import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const CsIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            d='M9.01984 3.0521C9.35938 2.71107 9.82933 2.5 10.3486 2.5C10.9049 2.5 11.4046 2.74226 11.748 3.12703C11.7745 3.15075 11.8006 3.17536 11.8261 3.20085L17.1294 8.50415C17.8616 9.23638 17.8616 10.4236 17.1294 11.1558C16.3971 11.888 15.2099 11.888 14.4777 11.1558L12.2236 8.90167V15.625C12.2236 16.6605 11.3841 17.5 10.3486 17.5C9.31305 17.5 8.47359 16.6605 8.47359 15.625V8.88301L6.20082 11.1558C5.46859 11.888 4.28141 11.888 3.54917 11.1558C2.81694 10.4235 2.81694 9.23636 3.54917 8.50413L8.85247 3.20083C8.90595 3.14735 8.96186 3.09777 9.01984 3.0521Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default CsIcon
